
<div class="row">
    <div class="p-0 m-0 col-xs-12 col-sm-12 breadcrumb-container">
      <ol class="breadcrumb breadcrumbCommonCls" *ngIf="menuItems?.length > 0">
        <li> <a [routerLink]="['']" class="k-icon k-i-home breadcrumbCommonCls"> </a> </li>
        <li> <span class="gry k-icon k-i-arrow-chevron-right breadcrumbCommonCls"> </span> </li>
        <li *ngFor="let breadcrumb of menuItems; last as isLast"
            class="justify-content-center">
          <span *ngIf="isLast || breadcrumb.label === 'Literature'"
                class="gry lnk" style="color:blue;">
            {{ breadcrumb.label }}
          </span>                             <!--written inline style ..need to write in scss file-->
          <a [routerLink]="[breadcrumb.url]"
             *ngIf="!isLast && breadcrumb.label !== 'Literature'">
            {{ breadcrumb.label }}
          </a>
          <span *ngIf=" !isLast" class="gry k-icon k-i-arrow-chevron-right breadcrumbCommonCls">
          </span>
        </li>
      </ol>
    </div>
  </div>
